import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthStateService } from '../../shared/services/auth-state.service';
import { BrandService } from '../../shared/services/brand.service';
import { ToastService } from '../service/toast.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard {
  constructor(
    private readonly authState: AuthStateService,
    private readonly brand: BrandService,
    private readonly router: Router,
    private readonly toast: ToastService,
    private readonly translate: TranslateService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const requiredRoles = (route.data?.['requiredRoles'] as string[] | undefined) ?? [];
    const pt = this.authState.productType;
    const roles = this.authState.roles;
    const result = this.brand.validateUserBrand(pt, roles, requiredRoles);
    if (result.ok) {
      return true;
    }

    this.toast.showWarning(this.translate.instant('ERROR_MESSAGES.NO_PERMISSION'));
    this.router.navigate(['/access-denied'], { queryParams: { from: state.url } });
    return false;
  }
}
